<template>
  <main id="contents" class="ticket-top-padding">
    <div class="page-top">
      <hgroup class="page-top-inner-wrap">
        <h1 class="page-title" tabindex="0">{{ pageTitle }}</h1>
        <h2 v-if="voucherType !== 'wavveon'" class="page-text">
          방송/영화/해외시리즈 무제한!
        </h2>
      </hgroup>
    </div>

    <div class="ticket-wrap">
      <div class="ticket-body">
        <voucher-banner
          v-if="voucherType !== 'wavveon'"
          banner-id="voucher_index"
        />
        <div class="voucher-wrap">
          <router-view :key="$route.name" name="voucherContent"></router-view>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import cookie from '@/common/utils/cookie'
  import constant from '@/common/resources/constant'
  import { scrollTop } from '@/common/utils/common'
  import { SET_CURRENT_MENU } from '@/common/resources/const'
  import { mapMutations } from 'vuex'
  import VoucherBanner from '@/components/voucher/VoucherBanner'
  import _ from 'lodash'
  export default {
    components: {
      VoucherBanner,
    },
    data() {
      return {
        voucherType: 'voucher',
        titleList: [
          { title: '이용권', type: 'voucher' },
          { title: '제휴', type: 'partner' },
          { title: '웨이브온 이용권', type: 'wavveon' },
        ],
      }
    },
    methods: {
      ...mapMutations([SET_CURRENT_MENU]),
      init() {
        if (_.get(this.$route, 'name', '') === 'wavveon') {
          this.voucherType = 'wavveon'
        } else {
          if (_.get(this.$route, 'query.voucherType', '') === 'partner')
            this.voucherType = 'partner'
          else this.voucherType = 'voucher'
        }
      },
    },
    computed: {
      pageTitle() {
        const typeIndex = _.findIndex(this.titleList, {
          type: this.voucherType,
        })
        return _.get(this.titleList, [typeIndex, 'title'], '')
      },
    },
    watch: {
      $route(newRoute, oldRoute) {
        this.init()
      },
    },
    mounted() {
      this[SET_CURRENT_MENU]('voucher')
    },
    created() {
      this.init()
      scrollTop()
      if (cookie.isWavveOn()) {
        cookie.removeItems({ keyList: ['pzInfo', 'cs', 'pz'] })
        cookie.setItem(
          'pz',
          JSON.stringify({ isPooqzone: false }),
          false,
          constant.URL_COOKIE_DOMAIN,
          '/',
        )
        window.location.reload()
      }
    },
  }
</script>
<style lang="scss" src="@/assets/scss/category/ticket.scss"></style>
